"use client";
import { Container } from "../../elements/container/container";
import { Text } from "../../elements/text/text";
import { downloadFile } from "../../lib/download-utils";
import { CardDocument } from "../../patterns/card-document/card-document";

export interface DocumentListCardProps {
  heading: string;
  description: string;
  documents: Array<{
    id: string;
    titleText: string;
    // allow either an href (server) or onClick (client) for flexibility in stories
    viewButton: {
      text: string;
      //href added as we cannot pass handler created in sever componnet and pass to client component
      href: string;
    };
    downloadButton: {
      text: string;
      //href added as we cannot pass handler created in sever componnet and pass to client component
      href: string;
    };
    image: {
      src: string;
      alt: string;
    };
  }>;
  //removed viewAllHref as it was not used
  /**
   * Whether to apply Container wrapper for consistent spacing
   * @default true
   */
  fluid?: boolean;
}

export function DocumentListCard(props: Readonly<DocumentListCardProps>) {
  const fluid = props.fluid ?? true;

  const content = (
    <section className="flex w-full flex-col items-start gap-5">
      {/* Intro Section */}
      <div className="flex w-full flex-col items-start gap-2.5">
        {/* Heading */}
        <div className="flex w-full items-center gap-2 pb-2">
          <Text variant="h2">{props.heading}</Text>
        </div>

        {/* Description */}
        <Text variant="body-md">{props.description}</Text>
      </div>

      {/* Documents Grid */}
      <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {props.documents.map((document) => (
          <CardDocument
            documentImageAltText={document.image.alt}
            documentImageSrcLink={document.image.src}
            downloadButtonText={document.downloadButton.text}
            id={document.id}
            key={document.id}
            onDownloadClick={() => {
              downloadFile(document.downloadButton.href, document.titleText);
            }}
            onViewClick={() => {
              window.open(document.viewButton.href, "_blank");
            }}
            titleText={document.titleText}
            viewButtonText={document.viewButton.text}
          />
        ))}
      </div>
    </section>
  );

  return fluid ? <Container>{content}</Container> : content;
}
